import {
  Drawer as MuiDrawer,
  SwipeableDrawer,
  DrawerProps,
  SwipeableDrawerProps,
} from "@mui/material";
import {DrawerItem} from "../../core/model/DrawerItem";
import {ReactNode, useEffect, useState} from "react";
import {useThemeContext} from "@theme";
import {DrawerContent} from "./drawer/DrawerContent";

const DRAWER_OPEN_WIDTH = 230;

const Drawer = ({
  drawerItems,
  open: openProps,
  drawerItemIndex,
  variant = "permanent",
  onChange,
  onItemClick,
}: {
  appName: string;
  drawerItems: (DrawerItem | ReactNode)[];
  open: boolean;
  drawerItemIndex: number;
  variant?: "permanent" | "persistent" | "temporary";
  onChange: (open: boolean) => void;
  onItemClick: (index: number, path: string) => void;
}) => {
  const {theme} = useThemeContext();
  const [open, setOpen] = useState<boolean>(openProps);

  useEffect(() => {
    if (open !== undefined) {
      setOpen(openProps);
    } else {
      setOpen(variant === "permanent");
    }
  }, [openProps]);

  useEffect(() => {
    if (open !== undefined) {
      onChange(open);
    }
  }, [open]);

  const handleDrawerItemClick = (index: number, path: string) => {
    if (variant === "temporary") {
      setOpen(false);
    }
    onItemClick(index, path);
    const onClick = (drawerItems[index] as DrawerItem).onClick;
    if (onClick) {
      onClick();
    }
  };

  const drawerProps: DrawerProps = {
    sx: {
      "& .MuiDrawer-paper": {
        position: "relative",
        borderRadius: 0,
        backgroundColor:
          variant === "permanent"
            ? theme.palette.background.paper
            : theme.palette.background.paper,
        borderRight: `2px solid ${theme.colors.secondaryContainer}`,
        width: DRAWER_OPEN_WIDTH,
        overflow: "hidden",
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        ...(!open && {
          pr: 0,
          transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: variant === "permanent" ? theme.spacing(7) : DRAWER_OPEN_WIDTH,
        }),
      },
    },
    variant,
    open,
    onClose: () => setOpen(false),
  };

  if (variant === "permanent") {
    <MuiDrawer {...drawerProps}>
      <DrawerContent
        items={drawerItems}
        selected={drawerItemIndex}
        open={open}
        setOpen={setOpen}
        onItemClick={handleDrawerItemClick}
      />
    </MuiDrawer>;
  }

  return (
    <SwipeableDrawer
      {...(drawerProps as SwipeableDrawerProps)}
      onOpen={() => setOpen(true)}>
      <DrawerContent
        items={drawerItems}
        selected={drawerItemIndex}
        open={open}
        setOpen={setOpen}
        onItemClick={handleDrawerItemClick}
      />
    </SwipeableDrawer>
  );
};

export {Drawer};
